import { OnlineLinkKey } from '@/typings';

export const online_link_name:Record<OnlineLinkKey, string> = {
    xiami: '虾米',
    netease: '网易云',
    qqmusic: 'QQ音乐',
    etc: '其他'
};

export const online_links_default = {
    xiami: {
        name: '虾米',
        url: ''
    },
    netease: {
        name: '网易云',
        url: ''
    },
    qqmusic: {
        name: 'QQ音乐',
        url: ''
    },
    etc: {
        name: '其他',
        url: ''
    }
};
